import Dashboard from "@material-ui/icons/Dashboard";
// core components/views for Admin layout
import DashboardPage from "../components/QADashboard";
import Error from "components/Error";
import List from "@material-ui/icons/List";
import Login from "../components/Login"
import Person from "@material-ui/icons/Person";
import ProdDashboard from "../components/ProdEnvInfo"
import ProdManifest from "../components/ProdManifest"
import QASignOff from "../components/QaPromotion";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: Dashboard,
    component: DashboardPage,
    layout: "/admin"
  },
  {
    path: "/qa",
    name: "QA Regression Sign Off",
    icon: Person,
    component: QASignOff,
    layout: "/admin"
  },
  {
    path: "/prodManifest",
    name: "Production Manifest",
    icon: List,
    component: ProdManifest,
    layout: "/admin"
  },
  {
    path: "/login",
    name: "Login",
    icon: List,
    component: Login,
    layout: "/admin"
  },  
  {
    path: "/envInfo",
    name: "Production Manifest",
    icon: List,
    component: ProdDashboard,
    layout: "/admin"
  },  
  {
    path: "/error",
    name: "Error",
    icon: List,
    component: Error,
    layout: "/admin"
  }
  
];

export default dashboardRoutes;
